<template>
  <div class="page-main">送货单列表</div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
